import { getStorageItem } from "../../../../utils/local-storage";
import { getApiHost } from '../../../../utils/hosts';

export enum StylePacksTypes  {
    SEGMENT= 'segment',
    TITLE='title',
    COUNTDOWN='countdown',
    WALKUP= 'walkup',
    BACKGROUND='background',
    TRANSITION= 'transition',
    BOOKEND='bookend',
    SLIDE= 'slide',
}

export enum Providers {
    CAPSULE = 'capsule',
    CUSTOM = 'custom',
}

const configAddition = {
    [StylePacksTypes.TITLE]: {
        "alpha-channel-enabled": true,
        "hls-enabled": false,
        "auto-crop": true,
    },
    [StylePacksTypes.SEGMENT]: {
        "alpha-channel-enabled": false,
        "hls-enabled": true,
        "auto-crop": false,
    },
    [StylePacksTypes.WALKUP]: {
        "alpha-channel-enabled": false,
        "hls-enabled": true,
        "auto-crop": true,
    },
    [StylePacksTypes.COUNTDOWN]: {
        "alpha-channel-enabled": false,
        "hls-enabled": true,
        "auto-crop": false,
    },
    [StylePacksTypes.TRANSITION]: {
        "alpha-channel-enabled": false,
        "hls-enabled": true,
        "auto-crop": true,
    },
    [StylePacksTypes.BACKGROUND]: {
        "alpha-channel-enabled": false,
        "hls-enabled": true,
        "auto-crop": true,
    },
    [StylePacksTypes.BOOKEND]: {
        "alpha-channel-enabled": false,
        "hls-enabled": true,
        "auto-crop": false,
    },
    [StylePacksTypes.SLIDE]: {
        "alpha-channel-enabled": false,
        "hls-enabled": true,
        "auto-crop": false,
    },
}
export type CapsuleItem = {
    key: string;
    display: string;
    type: string;
    default: string;
    required: boolean;
}

type CapsuleVariable = {
    name: string;
    type: string;
    default: string;
    validation: string | null;
    required: boolean;
    options: Array<{ name: string; value: string }> | null;
    userData: string;
}

export type GeneratedContent = {
    provider?: Providers; 
    type?: string; 
    name?: string;
    data?: CapsuleV3;
    content_type?: StylePacksTypes;
    locked?: boolean;
    thumbnail_url?: string; 
    video_url?: string;
    style_pack?: string;
}

type CapsuleConfig = {
    "alpha-channel-enabled": boolean;
    "hls-enabled": boolean;
    "auto-crop": boolean;
};

export type CapsuleV3 = {
    apiVersion: string;
    contentType: string;
    config:CapsuleConfig;
    variables: Array<CapsuleVariable>;
}

export enum StylepackGroups {
    ACADEMY= 'brandlive-academy',
    TICTACTOE= 'brandlive-tic-tac-toe',
    MONDRIAN = 'brandlive-mondrian',
    BACK_TO_SCHOOL = 'brandlive-back-to-school',
    ROTHKO = 'brandlive-rothko',
    TOPO = 'brandlive-topo',
}

export const updateContentTemplateType = (contentId: number, newType: string, token?:string ) => {
    // Dispatch action to update the content type in the store
    // Assuming you have an action creator called updateContentTemplateType
    // dispatch(updateContentTemplateType(contentId, newType));
    fetch(`${getApiHost()}/v2/greenroom/update-stylepack`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'bl-token': getStorageItem('token') || token,
        },
        body: JSON.stringify({ id: contentId, type: newType, name:'', data: {},  }),
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to update content template type');
        }
        return response.json();
    }
    )
    .then(data => {
        console.log('Content template type updated successfully:', data);
        return data
    }
    )
    .catch(error => {
        console.error('Error updating content template type:', error);
    });
};

export const getContentTemplatesOfGroup = async (style_pack: StylepackGroups, token?:string | null) => {
    try {
        const response = await fetch(`${getApiHost()}/v2/greenroom/stylepacks-migration/${style_pack}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'bl-token': getStorageItem('token') || token,
            },

        });

        if (!response.ok) {
            throw new Error('Failed to fetch content templates');
        }

        const data = await response.json();
        return data;
        
    } catch (error) {
        console.error('Error fetching content templates:', error);
    }
}

export const addContentTemplate = async (newTemplate: GeneratedContent, token: string) => {
    try {
        const response = await fetch(`${getApiHost()}/v2/greenroom/add-stylepack`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'bl-token': getStorageItem('token') || token,
            },
            body: JSON.stringify(newTemplate),
        });

        if (!response.ok) {
            throw new Error('Failed to add new content template');
        }

        const data = await response.json();
        console.log('New content template added successfully:', data);
        return data;
        
    } catch (error) {
        console.error('Error adding new content template:', error);
    }
}

export const updateContentTemplate = async ( contentId: number, newTemplate: GeneratedContent, token?:string |null) => {
    try {
        const response = await fetch(`${getApiHost()}/v2/greenroom/update-stylepack`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'bl-token': getStorageItem('token') || token,
            },
            body: JSON.stringify({...newTemplate, id: contentId}),
        });
        if (!response.ok) {
            throw new Error('Failed to update content template');
        }
        const data = await response.json();
        console.log('Content template updated successfully:', data);
        return data;
    } catch (error) {
        console.error('Error updating content template:', error);
    }
}

export const updateContentTemplateData = async (contentId: number, newTemplate: GeneratedContent) => {
    try {
        const response = await fetch(`${getApiHost()}/v2/greenroom/update-stylepack`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'bl-token': getStorageItem('token') || '',
            },
            body: JSON.stringify({...newTemplate, id: contentId}),
        });
        if (!response.ok) {
            throw new Error('Failed to update content template');
        }
        const data = await response.json();
        console.log('Content template updated successfully:', data);
        return data;
    } catch (error) {
        console.error('Error updating content template:', error);
    }
}

export const updateContentTemplateDefaultImage = async (contentId: number, newTemplate: string) => {
    try {
        const response = await fetch(`${getApiHost()}/v2/greenroom/update-stylepack`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'bl-token': getStorageItem('token') || '',
            },
            body: JSON.stringify({thumbnail_url: newTemplate, id: contentId}),
        });
        if (!response.ok) {
            throw new Error('Failed to update content template');
        }
        const data = await response.json();
        console.log('Content template updated successfully:', data);
        return data;
    } catch (error) {
        console.error('Error updating content template:', error);
    }
}


export const convertCapsuleVariablesToApi = (capsule: [CapsuleItem], contentType:StylePacksTypes):CapsuleV3 => {
    const accArray: Array<CapsuleVariable>= [];
    const dataArray = capsule.reduce((result, item) => {
        result.push ({
            name: item.display,
            type: item.type,
            default: item.default,
            validation: null,
            required: item.required,
            options: null,
            userData: item.key
        });
        return result;
    }, accArray);

    return {
        apiVersion: "v3",
        contentType,
        config:{
            ...configAddition[contentType],
        },
        variables: dataArray,
    }

}
